import PropTypes from 'prop-types';
import React from 'react';
import Link from '@ux/link';
import { FormattedMessage } from 'react-intl';
import { golf } from './enums';
import RewardPoints from './rewards-points';
import VIP from './vip';

export function UserDetails(props) {
  if (!props.loggedIn) {
    return null;
  }

  let details = null;
  const { vip } = props;

  if (props.preset === 'internal-header') {
    details = (
      <div className='account-name'>
        <FormattedMessage id={ golf.username } /> : { props.username }
      </div>
    );
  } else if (props.privateLabelType !== 3) {
    details = (
      <div>
        <div className='shopper-id'>
          <FormattedMessage id={ golf.shopperid } />: { props.shopperId }
        </div>
        <div className='shopper-pin'>
          <FormattedMessage id={ golf.pinLabel } />{' '}
          <Link
            urlArgs={ props.urlArgs }
            { ...props.urls.viewPin }
            data-eid={ props.eids.viewPin }
            target='_blank'>
            <FormattedMessage id={ golf.viewPin } />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      { details }
      { props.proshopper && !props.pcx && <RewardPoints rewardPoints={ props.rewardPoints } /> }
      { vip && <VIP details={ vip } /> }
    </div>
  );
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */
UserDetails.propTypes = {
  eids: PropTypes.object,
  loggedIn: PropTypes.bool,
  name: PropTypes.string,
  preset: PropTypes.string,
  privateLabelType: PropTypes.number,
  proshopper: PropTypes.bool,
  rewardPoints: PropTypes.number,
  shopperId: PropTypes.string,
  urls: PropTypes.object.isRequired,
  urlArgs: PropTypes.object,
  username: PropTypes.string,
  vip: PropTypes.object,
  pcx: PropTypes.bool
};

export default UserDetails;
